export default __webpack_public_path__ + "static/media/contact_allowed.94ecc307.svg";